import * as React from "react";
import PropTypes from "prop-types";

// Material
import {
    Card,
    CardMedia,
    Typography,
    Box,
    Grid,
    useMediaQuery,
    useTheme,
    Tooltip,
    Button,
} from "@material-ui/core";
import { registeredCardStyles } from "./style";

// Utils
import { getOrdinalNumber } from "@/utils/date";
import { ONLINE } from "@/store/actions/registeredEventsActions";

export default function RegisteredEventCard({
    classes,
    coverImage,
    title,
    location,
    dateTimeIsoFormat,
    onClickTitle,
    desktopCardWidth,
    raised,
    eventType,
    button,
    uniqueId,
    slotTime,
    showFullTitle,
    ...props
}) {
    const _classes = registeredCardStyles({ desktopCardWidth });
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const eventDateTime = new Date(dateTimeIsoFormat);
    const time = eventDateTime.toLocaleTimeString("en", {
        timeStyle: "short",
        hour12: true,
    });

    const eliptedTitle = (title) => {
        if (showFullTitle) return title;
        if (title.length > 40) {
            return `${title.substring(0, 40)}...`;
        }
        return title;
    };

    const date = `${getOrdinalNumber(eventDateTime.getDate())} ${eventDateTime.toLocaleString("default", {
        month: "long",
    })} ${eventDateTime.getFullYear()}`;

    const showEventType = () => {
        if (eventType)
            return (
                <span style={{ textTransform: "capitalize" }}>
                    {" |"}
                    <Box display={"inline-flex"} alignItems="center" justifyContent={"center"}>
                        {eventType.toLowerCase() === ONLINE ? (
                            <Box className={`${_classes.dot} ${_classes.success}`} />
                        ) : (
                            <Box className={`${_classes.dot} ${_classes.grey}`} />
                        )}
                    </Box>
                    {eventType}
                </span>
            );
        return "";
    };

    return (
        <Card raised={raised} {...props} className={_classes.containerCard}>
            <Box className={`${_classes.root} ${classes.cRoot}`}>
                <Box className={`${_classes.uniqueIdContainer}`}>
                    <CardMedia
                        className={`${_classes.media} ${classes.cMedia}`}
                        image={coverImage.src}
                        title={coverImage.alt}
                    />
                    {uniqueId && !isMobile && (
                        <Box>
                            <Typography className={` ${_classes.uniqueIdCard}`} variant={"body1"}>
                                Unique Id: {uniqueId}
                            </Typography>
                        </Box>
                    )}
                </Box>

                {uniqueId && isMobile && (
                    <Box>
                        <Typography className={` ${_classes.mobileUniqueIdCard}`} variant={"body1"}>
                            Unique Id: {uniqueId}
                        </Typography>
                    </Box>
                )}
                <Box className={_classes.cardContent}>
                    <div className={_classes.titleContainer}>
                        <Typography
                            className={`${_classes.title} ${onClickTitle && _classes.titleOnHover}`}
                            gutterBottom
                            onClick={onClickTitle}
                            variant="h2"
                        >
                            <>
                                <Tooltip title={title} variant={"body1"}>
                                    <span>{eliptedTitle(title)}</span>
                                </Tooltip>
                            </>
                        </Typography>
                    </div>
                    <div className={_classes.details}>
                        <Grid container>
                            <Grid item xs={10}>
                                <Typography color="primary" variant="h3" className={_classes.date}>
                                    {<>{date}</>}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Typography color="textPrimary" variant="subtitle1" className={_classes.otherDetails}>
                            {`${location} | ${slotTime ? slotTime.toUpperCase() : time}`} {showEventType()}
                        </Typography>
                    </div>
                </Box>
            </Box>
            {button && (
                <Box py={1} px={2}>
                    <div className={_classes.actionContainer}>
                        <Button onClick={button.onClick} variant="outlined" fullWidth color="primary">
                            {button.label}
                        </Button>
                    </div>
                </Box>
            )}
        </Card>
    );
}

RegisteredEventCard.propTypes = {
    classes: PropTypes.object,
    coverImage: PropTypes.object,
    title: PropTypes.string,
    location: PropTypes.string,
    dateTimeIsoFormat: PropTypes.string,
    onClickTitle: PropTypes.func,
    raised: PropTypes.bool,
    desktopCardWidth: PropTypes.string,
    eventType: PropTypes.string,
    direction: PropTypes.object,
    button: PropTypes.object,
    uniqueId: PropTypes.string,
    slotTime: PropTypes.string,
    showFullTitle: PropTypes.bool
};

RegisteredEventCard.defaultProps = {
    raised: false,
    onClickTitle: null,
    classes: {},
    eventType: null,
    direction: null,
    button: null,
    uniqueId: "",
    showFullTitle: false
};
